import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    load: "languageOnly",
    backend: {
      loadPath: "/assets/i18n/{{ns}}/{{lng}}.json",
    },
    debug: true,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
